module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "total"
  }, _vm._l((_vm.dataList), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "count"
    }, [_vm._v(_vm._s(item.count))]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dcda1b7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/total.vue
// module id = 572
// module chunks = 0